import { render, staticRenderFns } from "./Error401.vue?vue&type=template&id=4e44e4d2&"
import script from "./Error401.vue?vue&type=script&lang=js&"
export * from "./Error401.vue?vue&type=script&lang=js&"
import style0 from "./Error401.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e44e4d2')) {
      api.createRecord('4e44e4d2', component.options)
    } else {
      api.reload('4e44e4d2', component.options)
    }
    module.hot.accept("./Error401.vue?vue&type=template&id=4e44e4d2&", function () {
      api.rerender('4e44e4d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Error401.vue"
export default component.exports